import * as sup from "superstruct";

import { achievementResourceStruct } from "@/modules/achievements/api/achievementResourceStruct";
import { JsonApiClient } from "@/modules/api/utils/createJsonApiClient/createJsonApiClient";
import { createResponseStruct } from "@/modules/api/utils/jsonApiStructs";
import { userResourceStruct } from "@/modules/user/api/resources/userResourceStruct";

import { getRankingPath } from "../resources/rankingResourceConsts";

export const getRankingQuery = (
  jsonApi: JsonApiClient,
  {
    userGroupId,
  }: {
    userGroupId: string;
  }
) => {
  return jsonApi.getMany({
    path: getRankingPath(userGroupId),
    responseStruct: getRankingResponseStruct,
  });
};

const getRankingResponseStruct = createResponseStruct({
  data: sup.array(userResourceStruct),
  included: sup.array(achievementResourceStruct),
});

export type GetRankingResponse = sup.Infer<typeof getRankingResponseStruct>;
